import { Transformer } from "../types";

export const joinLines = (lines: string[]) => lines.join("\n");
export const getLines = (text: string) => text.split("\n");

export const createLineMapper: Transformer<Transformer<
    string
>> = transformer => text =>
    text
        .split("\n")
        .map(transformer)
        .join("\n");
